import React, { useState, useEffect, useRef } from "react";
import "./domain.css";

import Construction from "../../assets/images/construction.png";
import { useLocation } from "react-router-dom";

import { Link } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

const ConstructionDomain = () => {
  const [play, setPlay] = useState(false);

  const vidRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init();
  }, []);

  const handlePlay = () => {
    if (vidRef && vidRef.current) {
      if (vidRef.current.paused) {
        setPlay(true);
        vidRef.current.play();
      } else {
        setPlay(false);
        vidRef.current.pause();
      }
    }
  };

  return (
    <>
      <div className="domain-banner construction">
        <div className="bgoverlay"></div>
        <div className="container-fluid">
          <div className="content">
            <div
              className="heading"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              <div className="heading-flex">
                <h2>Construction</h2>
                <h4>
                  Empowering Construction Industry with eTraining Solutions
                </h4>
                <p>
                  In the construction industry, where tradition and precision
                  are highly valued, the idea of adopting innovative training
                  methods like eTraining may initially seem challenging.
                  However, eTraining is not just a passing fad – it is a
                  powerful tool with the potential to revolutionize how
                  construction professionals are trained and prepared for the
                  demands of their industry.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="domain-section">
        <div className="domain-banner-circle"></div>
        <div className="domain-section-content">
          <div
            className={play ? "domain-main-img play" : "domain-main-img"}
            
          >
            <img src={Construction} alt="" />
            <div className="domain-opq-dummy">
              <div class="step" onClick={handlePlay}>
                {play ? (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Bold"
                      viewBox="0 0 24 24"
                      width="40"
                      height="40"
                      fill="#37466F"
                    >
                      <path d="M9,17V7a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v10a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1Z"></path>
                      <path d="M14,17V7a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v10a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1Z"></path>
                    </svg>
                  </>
                ) : (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Bold"
                      viewBox="0 0 24 24"
                      width="70"
                      height="40"
                      fill="#37466F"
                    >
                      <path d="M9,17.879V6.707A1,1,0,0,1,10.707,6l5.586,5.586a1,1,0,0,1,0,1.414l-5.586,5.586A1,1,0,0,1,9,17.879Z"></path>
                    </svg>
                  </>
                )}

                <div class="ripple"></div>
                <div class="ripple"></div>
                <div class="ripple"></div>
              </div>
            </div>
            <div className="domain-player">
              <video ref={vidRef} controls controlsList="nodownload" muted>
                <source src="https://fidusindia.in/assets2/domains/videos/ConstructionDomain.mp4" />
              </video>
            </div>
          </div>
          <div className="domain-main">
            <div className="domain-main-content">
              <div className="" data-aos="fade-up" data-aos-duration="1500">
                <h2>Challenges Addressed by eTraining in Construction</h2>
                <p>
                  Traditional training methods can be restrictive and
                  time-consuming. Busy schedules often clash with rigid
                  classroom settings, leaving knowledge gaps and hindering
                  optimal patient care.
                </p>
              </div>

              <div className="construction-desc2-inner">
                <div
                  className="const-box"
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <div className="const-img-desc">
                    <img
                      src="https://fidusindia.in/assets2/domains/images/constDesc1.png"
                      alt="const-box"
                    />
                  </div>
                  <span>Safety and Compliance</span>
                  <div className="arrow-div"></div>
                  <div className="red-border-const"></div>
                </div>
                <div
                  className="const-box"
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <div className="const-img-desc">
                    <img
                      src="https://fidusindia.in/assets2/domains/images/constDesc2.png"
                      alt="const-box"
                    />
                  </div>
                  <span>Skills Shortage and Training Needs</span>
                  <div className="arrow-div"></div>
                  <div className="red-border-const"></div>
                </div>
                <div
                  className="const-box"
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <div className="const-img-desc">
                    <img
                      src="https://fidusindia.in/assets2/domains/images/constDesc3.png"
                      alt="const-box"
                    />
                  </div>
                  <span>Project Management Efficiency</span>
                  <div className="arrow-div"></div>
                  <div className="red-border-const"></div>
                </div>
                <div
                  className="const-box"
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <div className="const-img-desc">
                    <img
                      src="https://fidusindia.in/assets2/domains/images/constDesc4.png"
                      alt="const-box"
                    />
                  </div>
                  <span>Technology Adoption and Innovation</span>
                  <div className="arrow-div"></div>
                  <div className="red-border-const"></div>
                </div>
                <div
                  className="const-box"
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <div className="const-img-desc">
                    <img
                      src="https://fidusindia.in/assets2/domains/images/constDesc5.png"
                      alt="const-box"
                    />
                  </div>
                  <span>Quality Assurance and Quality Control</span>
                  <div className="arrow-div"></div>
                  <div className="red-border-const"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="domain-main reverse">
            <div className="domain-main-content">
              <div className="" data-aos="fade-up" data-aos-duration="1500">
                <h2>A Natural Evolution of Training</h2>
                <p>
                  Digital training offers a dynamic and efficient way to ensure
                  that every member of your team is equipped with the knowledge
                  and skills they need to succeed. It empowers construction
                  companies to navigate the complex landscape efficiently and
                  cost-effectively, offering:
                </p>
              </div>

              <div className="const-desc-circles-inner">
                <div
                  className="circle-const aos-init aos-animate"
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <span>Flexibility in Learning</span>
                </div>
                <div
                  className="circle-const aos-init aos-animate"
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <span>Cost Savings</span>
                </div>
                <div
                  className="circle-const aos-init aos-animate"
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <span>Central Deployment</span>
                </div>
                <div
                  className="circle-const aos-init aos-animate"
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <span>Up-to-Date Training</span>
                </div>
                <div
                  className="circle-const aos-init aos-animate"
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <span>Onboarding and Retention</span>
                </div>
              </div>
              <p data-aos="fade-up" data-aos-duration="1500">
                In a constantly evolving industry, continuous learning and
                upskilling are imperative. eTraining is a strategic investment
                in the future of your construction business, empowering your
                workforce for success. .
              </p>
            </div>
          </div>
          <div className="domain-main">
            <div className="domain-main-content" data-aos="fade-up" data-aos-duration="1500">
              <h4>
                Embrace the potential of eTraining today and equip your
                workforce for success tomorrow.
              </h4>
              <Link className="read-more-product" to={"/request"}>
                <span>Contact Us !</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConstructionDomain;
